<h1 style="padding-top: 2rem;">Step 4: Keep a Regular Sleep Schedule</h1>
<div class="row">
    <div class="col-md-6" style="font-family: Karla; font-size 14px;">
        <p>
            The last step in the treatment is to have a regular sleep routine, which means to get up
            at
            the same time every day of the week, no matter how long you have slept the night before. Why?
        </p><br>

        <p>

            The basic reason is that getting up at the same time every day helps to “set" or "resynchronize” your
            biological
            clock with the environmental clock. Many people with insomnia will try to sleep whenever they can to “catch
            up
            on sleep”.
        </p><br>

        <p>

            Unfortunately, having an irregular sleep and wakeup time confuses the biological clock. In fact, wakeup time
            is
            probably the most important cue for setting the biological clock. It does not only set the tone for the
            remaining day, but it also allows you to be exposed to light, which is a strong stimulant to keep you awake.
        </p><br>

        <p>

            Some of you may have concerns now about getting up after only a few hours of sleep and being unable to
            function
            throughout the day. It is true that you will feel unwell in the first few days, but your sleep pressure will
            slowly build up. Your biological clock as well as the exposure to external sun light will cause your sleep
            pattern to start reshaping itself and provide you with a healthier sleep structure, which will in turn allow
            you
            to have a more consolidated and refreshing sleep over 1-2 months of time.
        </p><br>

        <!--<p>

            Next, we will need you to complete the sleep diary so that it can be reviewed by your health care provider.

        </p><br>-->

        <p>

            Based on the sleep diary provided, we will set the mutually agreed sleep and wake up time that is most
            feasible
            for you.

        </p><br>

        <p>

            Over the next few weeks, we will work together to improve your sleep routine so that you can get a Tranquil
            sleep.
        </p><br>


    </div>
    <div class="col-md-6">
        <div class="row justify-content-around">
            <img src="/assets/actionplan-step4-1.png" style="width: 70%;" />
            <q style="width: 90%;">
                Your biological clock as well as the exposure to external sunlight will cause your sleep patt
            </q>
        </div>
    </div>
</div>
<style>
    q::before {
        color: #055D9D;
        display: block;
        content: open-quote;
        font-size: 2rem;
    }

    q {
        quotes: '\201c''\201d';
        font-size: 20px;
        font-family: 'Karla';
        font-weight: bold;
        line-height: 32px;
        padding-left: 2rem
    }

    q::after {
        color: #055D9D;
        display: block;
        content: close-quote;
        font-size: 2rem;
    }
</style>